import { Checkbox, Snackbar } from "@material-ui/core";

import { getAllWarehousesManager } from "../../reduxSaga/actions";
import { useSelector, useDispatch } from "react-redux";

import { useEffect, useState } from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { Alert } from "@material-ui/lab";
import WarehouseService from "../../services/WarehouseService";
import { useNavigate } from "react-router-dom";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
const AddWarehouse = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const warehousesManager = useSelector(
    (state) => state.staff.warehousesManager.success
  );
  const [selectedOptionDevis, setSelectedOptionDevis] = useState(null);
  const [deviseChoosen, setDeviseChoosen] = useState(null);

  const styles = {
    container: (base) => ({
      ...base,
      flex: 1,
    }),
  };
  const [warehouseName, setWarehouseName] = useState("");
  const [warehouseRef, setWarehouseRef] = useState("");
  const [warehouseAddress, setWarehouseAddress] = useState("");

  const animatedComponents = makeAnimated();
  const [showElement, setShowElement] = useState([]);

  const [warehouseDesc, setWarehouseDesc] = useState("");

  const [confirmWarehouseModel, setConfirmWarehouseModel] = useState();
  const [onConfirmAddWarehouse, setOnConfirmAddWarehouse] = useState(false);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [isCancel, setIsCancel] = useState(false);
  const [selectedOptionWarehouseManager, setSelectedOptionWarehouseManager] =
    useState(null);
  const [warehouseManagerId, setWarehouseManagerId] = useState([]);
  const [allManagers, setAllManagers] = useState([]);
  const [listManagersId, setListManagersId] = useState([]);
  const [allCurrencies, setAllCurrencies] = useState([
    { value: "TND", label: "DNT" },
    { value: "EUR", label: "Euro" },
    { value: "USD", label: "US Dollar" },
    { value: "SAR", label: "Saudi Riyal" },
    { value: "AED", label: "United Arab Emirates Dirham" },
    { value: "CAD", label: "Canadian Dollar" },
    { value: "CNY", label: "Chinese Yuan" },
  ]);

  const [virtualWarehouse, setVirtualWarehouse] = useState(0);
  const [priceWarehouse, setPriceWarehouse] = useState(0);


  const [deviseSelectPlaceHolder, setDeviseSelectPlaceHolder] =
    useState("Choisir...");
  const [
    warehouseManagerSelectPlaceHolder,
    setWarehouseManagerSelectPlaceHolder,
  ] = useState("Choisir un manager");
  useEffect(() => {
    dispatch(getAllWarehousesManager());
    if (localStorage.getItem("status") == null) {
      setShowElement(["notConnected"]);
    } else {
      setShowElement(JSON.parse(localStorage.getItem("status")));
    }
  }, []);
  useEffect(() => {
    setAllManagers([]);

    warehousesManager &&
      warehousesManager.map((element, i) => {
        if (i === 0) {
          setWarehouseManagerId(element.id);
        }
        setAllManagers((oldArray) => [
          ...oldArray,
          {
            value: element.id,
            label: element.firstName + " " + element.lastName,
          },
        ]);
      });
  }, [warehousesManager]);
  useEffect(() => {
    if (
      onConfirmAddWarehouse === false &&
      confirmWarehouseModel != null &&
      isCancel === false
    ) {
      setOpenSuccessAlert(true);
      setSuccessAlertText("Ajouté avec succès");
    }
  }, [onConfirmAddWarehouse]);

  const onChangeNameHandler = (event) => {
    setWarehouseName(event.target.value);
  };
  const onChangeRefHandler = (event) => {
    setWarehouseRef(event.target.value);
  };
  const onChangeAddressHandler = (event) => {
    setWarehouseAddress(event.target.value);
  };

  const onChangeDescriptionHandler = (event) => {
    setWarehouseDesc(event.target.value);
  };

  const onValidWarehouseHandler = () => {
    if (warehouseName === "") {
      setErrorAlertText("Libellé est vide !");
      setOpenErrorAlert(true);
    } else if (deviseChoosen === null) {
      setErrorAlertText("La devise est vide !");
      setOpenErrorAlert(true);
    } else if (warehouseRef === "") {
      setErrorAlertText("Le réference est vide ! ");
      setOpenErrorAlert(true);
    } else if (listManagersId.length === 0) {
      setErrorAlertText("Aucun responsable ! ");
      setOpenErrorAlert(true);
    } else if (warehouseAddress === 0) {
      setErrorAlertText("L'adresse est vide ! ");
      setOpenErrorAlert(true);
    } else {
      let listManagers = [];
      listManagersId &&
        listManagersId.map((element, i) => {
          listManagers.push(element.value);
        });

      let warehouseModel = {
        name: warehouseName,
        ref: warehouseRef,
        listManagers: listManagers,
        idUser: getCurrentUserId(),
        description: warehouseDesc,
        address: warehouseAddress,
        devise: deviseChoosen,
        deviseName: deviseSelectPlaceHolder,
        vitualWarehouse: virtualWarehouse,
        priceWarehouse: priceWarehouse,
      };
      WarehouseService.addWarehouse(warehouseModel)
        .then((response) => {
          if (response.data["success"]) {
            setOpenSuccessAlert(true);
            setSuccessAlertText("Enregistrement avec succées");
            setTimeout(() => {
              navigate(`/warehouses`);
            }, 2000);
          } else {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur :erreur serveur ");
          }
        })
        .catch((e) => {
          console.log("error", e);
        });
    }
  };

  const onchooseVirtualWarehouseHandler = () => {
    setVirtualWarehouse(1);
  };
  const onchoosePriceWarehouseHandler = () => {
    setPriceWarehouse(priceWarehouse ===1 ? 0 :1);
  };
  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };
  const onChangeSelectedWarehouseManager = (selectedOption) => {
    setSelectedOptionWarehouseManager();
    setListManagersId(selectedOption);
  };
  const onChangeSelectedDevis = (selectedOptionn) => {
    setSelectedOptionDevis(selectedOptionn.value);
    setDeviseChoosen(selectedOptionn.value);
    setDeviseSelectPlaceHolder(selectedOptionn.label);
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item">Home</li>
                <li class="breadcrumb-item active">Ajouter dépôt</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content ">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-dark">
                <div className="card-header">
                  <h5 className="card-title"> Ajouter un dépôt</h5>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label htmlFor="inputName">
                          Libellé <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          placeholder="Ajouter libellé "
                          onChange={onChangeNameHandler}
                          type="text"
                          id="inputName"
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label htmlFor="inputName">
                          Réference <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          placeholder="Ajouter réference "
                          onChange={onChangeRefHandler}
                          type="text"
                          id="inputName"
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label>
                          Devise <span style={{ color: "red" }}>*</span>
                        </label>
                        <Select
                          closeMenuOnSelect={true}
                          components={animatedComponents}
                          defaultValue={selectedOptionDevis}
                          onChange={onChangeSelectedDevis}
                          options={allCurrencies}
                          placeholder={deviseSelectPlaceHolder}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label htmlFor="inputName">
                          Adresse <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          placeholder="Ajouter adresse "
                          onChange={onChangeAddressHandler}
                          type="text"
                          id="inputName"
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label>
                          Choisir le responsable de dépôt{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>

                        <Select
                          styles={styles}
                          isMulti
                          closeMenuOnSelect={true}
                          components={animatedComponents}
                          defaultValue={selectedOptionWarehouseManager}
                          onChange={onChangeSelectedWarehouseManager}
                          options={allManagers}
                          placeholder={warehouseManagerSelectPlaceHolder}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label htmlFor="inputDescription">Description</label>
                        <textarea
                          placeholder="Saisir..."
                          onChange={onChangeDescriptionHandler}
                          id="inputDescription"
                          className="form-control"
                          rows={2}
                        />
                      </div>
                    </div>
                  </div>
                  {showElement.includes("ADMIN") && (
                    <div className=" d-flex ">
                      <div class="form-group">
                        <Checkbox
                          label="virtualWarehouse"
                          value={virtualWarehouse}
                          onChange={onchooseVirtualWarehouseHandler}
                          style={{ color: "black" }}
                        />

                        <label class="form-check-label" for="inlineRadio1">
                          Dépôt virtuel
                        </label>
                      </div>
                      <div class="form-group ml-5">
                        <Checkbox
                          checked={priceWarehouse === 0 ? false : true}
                          label="priceWarehouse"
                          value={priceWarehouse}
                          onChange={onchoosePriceWarehouseHandler}
                          style={{ color: "black" }}
                        />

                        <label class="form-check-label" for="inlineRadio1">
                          Dépôt des prix
                        </label>
                      </div>
                    </div>

                  )}
                </div>

                <div class="card-footer" style={{ marginTop: "1%" }}>
                  <button
                    class="btn btn-dark float-right"
                    style={{ marginTop: "1%" }}
                    onClick={onValidWarehouseHandler}
                  >
                    Confirmer
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default AddWarehouse;
